// src/components/Contact.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

const InfoRow = ({ icon, label, value, href }) => (
  <div
    style={{
      display: "flex",
      alignItems: "flex-start",
      gap: "16px",
      padding: "20px",
      borderRadius: "14px",
      background: "rgba(64,190,180,0.04)",
      border: "1px solid rgba(64,190,180,0.12)",
      marginBottom: "16px",
    }}
  >
    <div
      style={{
        width: "40px",
        height: "40px",
        borderRadius: "10px",
        background: "rgba(64,190,180,0.1)",
        border: "1px solid rgba(64,190,180,0.2)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px",
        flexShrink: 0,
      }}
    >
      {icon}
    </div>
    <div>
      <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "11px", fontWeight: 600, letterSpacing: "1.5px", textTransform: "uppercase", marginBottom: "4px" }}>
        {label}
      </p>
      {href ? (
        <a
          href={href}
          style={{
            color: "#40BEB4",
            textDecoration: "none",
            fontSize: "15px",
            fontWeight: 500,
            borderBottom: "1px solid rgba(64,190,180,0.3)",
            paddingBottom: "1px",
          }}
        >
          {value}
        </a>
      ) : (
        <p style={{ color: "rgba(255,255,255,0.75)", fontSize: "15px", fontWeight: 500, margin: 0 }}>
          {value}
        </p>
      )}
    </div>
  </div>
);

const Contact = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        background: "linear-gradient(160deg, #071520 0%, #0a1e2e 35%, #071018 100%)",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "48px 24px 72px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Grid background */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `
            linear-gradient(rgba(64,190,180,0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(64,190,180,0.03) 1px, transparent 1px)
          `,
          backgroundSize: "48px 48px",
          pointerEvents: "none",
        }}
      />

      {/* Back button */}
      <div style={{ width: "100%", maxWidth: "720px", marginBottom: "32px", position: "relative", zIndex: 1 }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: "rgba(64,190,180,0.08)",
            border: "1px solid rgba(64,190,180,0.2)",
            color: "#40BEB4",
            padding: "8px 20px",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "13px",
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          ← Back
        </button>
      </div>

      {/* Card */}
      <div
        style={{
          maxWidth: "720px",
          width: "100%",
          background: "rgba(10, 25, 40, 0.92)",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(64,190,180,0.2)",
          borderRadius: "24px",
          padding: "48px",
          position: "relative",
          zIndex: 1,
          boxShadow: `
            0 0 0 1px rgba(255,255,255,0.03) inset,
            0 24px 64px rgba(0,0,0,0.6),
            0 0 48px rgba(64,190,180,0.07)
          `,
        }}
      >
        {/* Header */}
        <div style={{ marginBottom: "40px", textAlign: "center" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "48px",
              height: "48px",
              borderRadius: "12px",
              background: "rgba(64,190,180,0.1)",
              border: "1px solid rgba(64,190,180,0.25)",
              marginBottom: "16px",
              fontSize: "22px",
            }}
          >
            ✉️
          </div>
          <h1 style={{ fontSize: "28px", fontWeight: 700, color: "#40BEB4", marginBottom: "8px", letterSpacing: "-0.3px" }}>
            Contact Us
          </h1>
          <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "13px" }}>
            We're here to help with any queries about the KYC process.
          </p>
        </div>

        {/* Divider */}
        <div style={{ height: "1px", background: "linear-gradient(90deg, transparent, rgba(64,190,180,0.25), transparent)", marginBottom: "36px" }} />

        <InfoRow icon="🏢" label="Company" value="Advitiya Tantragyan Research and Development Labs Pvt Ltd" />
        <InfoRow icon="📧" label="Email" value="advitiyaoffice@gmail.com" href="mailto:advitiyaoffice@gmail.com" />

        {/* ── PRICING BLOCK ── */}
        <div
          style={{
            marginTop: "8px",
            marginBottom: "16px",
            padding: "24px",
            borderRadius: "16px",
            background: "rgba(64,190,180,0.06)",
            border: "1px solid rgba(64,190,180,0.25)",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* subtle glow */}
          <div style={{
            position: "absolute", inset: 0,
            background: "radial-gradient(ellipse at 50% 0%, rgba(64,190,180,0.08) 0%, transparent 70%)",
            pointerEvents: "none",
          }} />

          <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "11px", fontWeight: 600, letterSpacing: "1.5px", textTransform: "uppercase", marginBottom: "16px" }}>
            💰 Pricing
          </p>

          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "12px" }}>
            <div>
              <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "14px", marginBottom: "4px" }}>
                Video KYC Verification Service
              </p>
              <p style={{ color: "rgba(255,255,255,0.4)", fontSize: "12px", lineHeight: "1.6", margin: 0 }}>
                Aadhaar-based identity verification via DigiLocker
              </p>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{
                fontSize: "28px",
                fontWeight: 800,
                color: "#40BEB4",
                letterSpacing: "-1px",
                lineHeight: 1,
              }}>
                ₹0
              </div>
              <p style={{ color: "rgba(64,190,180,0.6)", fontSize: "12px", marginTop: "4px", fontWeight: 600 }}>
                FREE — No charges applicable
              </p>
            </div>
          </div>

          <div style={{ height: "1px", background: "rgba(64,190,180,0.12)", margin: "16px 0" }} />

          <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
            {[
              "No registration fee",
              "No transaction charges in INR",
              "No hidden costs",
            ].map((point, i) => (
              <li key={i} style={{ display: "flex", alignItems: "center", gap: "8px", color: "rgba(255,255,255,0.5)", fontSize: "13px", marginBottom: i < 2 ? "8px" : 0 }}>
                <span style={{ color: "#40BEB4", fontSize: "11px" }}>✓</span>
                {point}
              </li>
            ))}
          </ul>
        </div>
        

        {/* About platform */}
        <div
          style={{
            padding: "20px",
            borderRadius: "14px",
            background: "rgba(64,190,180,0.04)",
            border: "1px solid rgba(64,190,180,0.12)",
          }}
        >
          <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "11px", fontWeight: 600, letterSpacing: "1.5px", textTransform: "uppercase", marginBottom: "12px" }}>
            About This Platform
          </p>
          <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
            {[
              "Aadhaar-based identity verification using DigiLocker for KYC purposes.",
              "User consent is taken before accessing any Aadhaar data.",
              "Compliant with applicable Indian data privacy regulations.",
            ].map((point, i) => (
              <li key={i} style={{ display: "flex", alignItems: "flex-start", gap: "10px", marginBottom: i < 2 ? "10px" : 0, color: "rgba(255,255,255,0.55)", fontSize: "14px", lineHeight: "1.6" }}>
                <span style={{ color: "#40BEB4", flexShrink: 0, marginTop: "3px" }}>✓</span>
                {point}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Contact;
